import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { ENUM__connection_state } from '@/enums/ENUM__connection_state';
import { local_network_set_state } from '@/state/network/local_network_set_state';
import { store } from '@/state/store';
import { decode } from '@msgpack/msgpack';
import { ENetworkEventBothWays } from '@shared/network/ENetworkEventBothWays';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { FN_SERIALIZATION__data_deserialize } from '@shared/serialization/FN_SERIALIZATION__data_deserialize';
import { logw } from '@shared/utils/utils_logs';
import { Socket } from 'socket.io-client';
import { try_log_server_to_client } from '../_methods/try_log_in_client';
import { service_socketio_client } from '../service_socketio_client';

let system_events = [ENetworkEventBothWays.PING_TIMEOUT, ENetworkEventBothWays.IO_CLIENT_DISCONNECT, ENetworkEventBothWays.TRANSPORT_CLOSE];

export function SOCKETIO_MIDDLEWARE__on(socket: Socket) {
  // Save original socket.on method
  const original_function_on = socket.on.bind(socket);

  // Override the socket.on method to apply the middleware
  socket.on = (event: string, callback: (data: any) => void) => {
    // Intercept the received data and apply the transformation if the class type is defined
    const middleware = (data_packed: any) => {
      ENUM__network_event_client_to_server;
      if (typeof data_packed == 'string' && system_events.includes(data_packed)) {
        if (CONSTANTS__client.SERVICE_SOCKETIO_LOGGER_ENABLED) logw('socket disconnected');

        store.dispatch(local_network_set_state(ENUM__connection_state.DISCONNECTED));
        service_socketio_client.is_connection_authorized = false;
        return;
      }

      let data_original = data_packed;

      if (data_packed instanceof ArrayBuffer) data_packed = new Uint8Array(data_packed);

      if (data_packed instanceof Uint8Array) {
        data_original = data_packed.byteLength == 0 ? null : decode(data_packed);
      }

      if (typeof data_packed == 'string') debugger;

      try_log_server_to_client(event, data_packed);

      let data_deserialized = FN_SERIALIZATION__data_deserialize(data_original);
      callback(data_deserialized); // Pass the transformed data to the original callback
    };

    // Call the original socket.on method with the wrapped callback
    return original_function_on(event, middleware);
  };
}
